import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { API_BASE_URL } from '../../services/api';
import {
  ADMIN_COLORS,
  AdminStatCards, AdminStatCard, AdminStatValue, AdminStatLabel,
  AdminCard, AdminTitle, AdminLoading
} from './AdminShared';

const StatSub = styled.div`
  font-size: 0.75rem;
  color: ${ADMIN_COLORS.textMuted};
  margin-top: 0.5rem;
`;

const RoleBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 0.75rem;
`;

const RoleName = styled.span`
  min-width: 120px;
  font-size: 0.9rem;
  color: ${ADMIN_COLORS.text};
  text-transform: capitalize;
`;

const RoleBarFill = styled.div`
  flex: 1;
  height: 24px;
  background: #f3f4f6;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

const RoleFill = styled.div`
  height: 100%;
  background: ${props => props.color || ADMIN_COLORS.accent};
  border-radius: 12px;
  width: ${props => props.percent}%;
  transition: width 0.5s ease;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 8px;
  min-width: ${props => props.percent > 0 ? '30px' : '0'};
`;

const RoleCount = styled.span`
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
`;

const roleColors = {
  admin: '#dc2626',
  mentor: '#7c3aed',
  estudiante: '#0891B2',
  coordinador: '#059669',
  default: '#6366f1'
};

const AdminDashboardStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/admin/dashboard-stats.php`);
        if (res.data?.success) {
          setStats(res.data);
        }
      } catch (err) {
        console.error('Error cargando estadísticas:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) return <AdminLoading>Cargando estadísticas...</AdminLoading>;
  if (!stats) return <div style={{ padding: '2rem', color: ADMIN_COLORS.danger }}>Error cargando datos</div>;

  const maxCount = Math.max(...(stats.role_distribution || []).map(r => r.count), 1);

  return (
    <div>
      <AdminStatCards>
        <AdminStatCard $color="#0891B2">
          <AdminStatValue>{stats.total_users}</AdminStatValue>
          <AdminStatLabel>Usuarios Registrados</AdminStatLabel>
          <StatSub>Total en la plataforma</StatSub>
        </AdminStatCard>

        <AdminStatCard $color={ADMIN_COLORS.success}>
          <AdminStatValue>{stats.active_users}</AdminStatValue>
          <AdminStatLabel>Usuarios Activos</AdminStatLabel>
          <StatSub>{stats.active_rate}% de tasa de actividad (7 días)</StatSub>
        </AdminStatCard>

        <AdminStatCard $color="#7c3aed">
          <AdminStatValue>{stats.total_documents}</AdminStatValue>
          <AdminStatLabel>Contenidos</AdminStatLabel>
          <StatSub>Contenidos disponibles</StatSub>
        </AdminStatCard>
      </AdminStatCards>

      <AdminCard>
        <AdminTitle as="h3" style={{ fontSize: '1rem', marginBottom: '1rem' }}>Distribución por Grupo / Rol</AdminTitle>
        {(stats.role_distribution || []).map((role, i) => (
          <RoleBar key={i}>
            <RoleName>{role.role}</RoleName>
            <RoleBarFill>
              <RoleFill
                percent={(role.count / maxCount) * 100}
                color={roleColors[role.role] || roleColors.default}
              >
                <RoleCount>{role.count}</RoleCount>
              </RoleFill>
            </RoleBarFill>
          </RoleBar>
        ))}
      </AdminCard>
    </div>
  );
};

export default AdminDashboardStats;
